export const RESPONSE_TYPE = 'token id_token';
export const SCOPE = 'openid profile email';
export const AUDIENCE = 'https://rdo-api.rouseanalytics.com';
